//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

// state
const agentsListSelector = (state: RootState) => state.agent.agents.list;
const agentsListDataSelector = (state: RootState) => state.agent.agents.list.data;
const agentsListErrorSelector = (state: RootState) => state.agent.agents.list.error;
const agentsListFetchingSelector = (state: RootState) => state.agent.agents.list.isFetching;

//selectors
export const selectList = createSelector(agentsListSelector, (list) => list);
export const selectListData = createSelector(agentsListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectListDataColumnsSort = createSelector(agentsListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectListError = createSelector(agentsListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(agentsListFetchingSelector, (isFetching) => isFetching);

//Wallets List
const agentsWalletsDataSelector = (state: RootState) => state.agent.agents.wallets.data;
const agentsWalletsErrorSelector = (state: RootState) => state.agent.agents.wallets.error;
const agentsWalletsFetchingSelector = (state: RootState) => state.agent.agents.wallets.isFetching;

export const selectWalletsData = createSelector(agentsWalletsDataSelector, (data) => data);
export const selectWalletsError = createSelector(agentsWalletsErrorSelector, (error) => error);
export const selectWalletsIsFetching = createSelector(agentsWalletsFetchingSelector, (isFetching) => isFetching);

//Wallets List
const agentsDescendantAgentsDataSelector = (state: RootState) => state.agent.agents.descendantAgents.data;
const agentsDescendantAgentsErrorSelector = (state: RootState) => state.agent.agents.descendantAgents.error;
const agentsDescendantAgentsFetchingSelector = (state: RootState) => state.agent.agents.descendantAgents.isFetching;

export const selectDescendantAgentsData = createSelector(agentsDescendantAgentsDataSelector, (data) => data);
export const selectDescendantAgentsError = createSelector(agentsDescendantAgentsErrorSelector, (error) => error);
export const selectDescendantAgentsIsFetching = createSelector(agentsDescendantAgentsFetchingSelector, (isFetching) => isFetching);


//Agent Roles
const agentsRolesDataSelector = (state: RootState) => state.agent.agents.agentRoles.data;
const agentsRolesErrorSelector = (state: RootState) => state.agent.agents.agentRoles.error;
const agentsRolesFetchingSelector = (state: RootState) => state.agent.agents.agentRoles.isFetching;

export const selectAgentsRolesData = createSelector(agentsRolesDataSelector, (data) => data);
export const selectAgentsRolesError = createSelector(agentsRolesErrorSelector, (error) => error);
export const selectAgentsRolesIsFetching = createSelector(agentsRolesFetchingSelector, (isFetching) => isFetching);


//WalletIdentities
const agentsWalletIdentitiesDataSelector = (state: RootState) => state.agent.agents.walletIdentities.data;
const agentsWalletIdentitiesErrorSelector = (state: RootState) => state.agent.agents.walletIdentities.error;
const agentsWalletIdentitiesFetchingSelector = (state: RootState) => state.agent.agents.walletIdentities.isFetching;

export const selectWalletIdentitiesData = createSelector(agentsWalletIdentitiesDataSelector, (data) => data);
export const selectWalletIdentitiesError = createSelector(agentsWalletIdentitiesErrorSelector, (error) => error);
export const selectWalletIdentitiesIsFetching = createSelector(agentsWalletIdentitiesFetchingSelector, (isFetching) => isFetching);

//CreateAgent
const agentsCreateAgentDataSelector = (state: RootState) => state.agent.agents.createAgent.data;
const agentsCreateAgentErrorSelector = (state: RootState) => state.agent.agents.createAgent.error;
const agentsCreateAgentFetchingSelector = (state: RootState) => state.agent.agents.createAgent.isFetching;

export const selectCreateAgentData = createSelector(agentsCreateAgentDataSelector, (data) => data);
export const selectCreateAgentError = createSelector(agentsCreateAgentErrorSelector, (error) => error);
export const selectCreateAgentIsFetching = createSelector(agentsCreateAgentFetchingSelector, (isFetching) => isFetching);

//DetailsListRow
const agentsDetailsAgentDataSelector = (state: RootState) => state.agent.agents.details.data;
const agentsDetailsAgentErrorSelector = (state: RootState) => state.agent.agents.details.error;
const agentsDetailsAgentFetchingSelector = (state: RootState) => state.agent.agents.details.isFetching;

export const selectDetailsListAgentData = createSelector(agentsDetailsAgentDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'agentStatus' };
      }
      if (item.name === 'level') {
        return { ...item, type: 'level' };
      }
      if (item.name === 'type') {
        return { ...item, type: 'agentType' };
      }
      if (item.name === 'username') {
        return { ...item, type: 'shortUsername' };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        countries: item.countries.map((geo: string) => {
          return {
            id: geo,
            label: geo,
          }
        })
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectDetailsListAgentError = createSelector(agentsDetailsAgentErrorSelector, (error) => error);
export const selectDetailsListAgentIsFetching = createSelector(agentsDetailsAgentFetchingSelector, (isFetching) => isFetching);

//Enable Wallet
const agentsEnableWalletDataSelector = (state: RootState) => state.agent.agents.enableWallet.data;
const agentsEnableWalletErrorSelector = (state: RootState) => state.agent.agents.enableWallet.error;
const agentsEnableWalletFetchingSelector = (state: RootState) => state.agent.agents.enableWallet.isFetching;

export const selectEnableWalletData = createSelector(agentsEnableWalletDataSelector, (data) => data);
export const selectEnableWalletError = createSelector(agentsEnableWalletErrorSelector, (error) => error);
export const selectEnableWalletIsFetching = createSelector(agentsEnableWalletFetchingSelector, (isFetching) => isFetching);


//Enable Wallet
const agentsDisableWalletDataSelector = (state: RootState) => state.agent.agents.disableWallet.data;
const agentsDisableWalletErrorSelector = (state: RootState) => state.agent.agents.disableWallet.error;
const agentsDisableWalletFetchingSelector = (state: RootState) => state.agent.agents.disableWallet.isFetching;

export const selectDisableWalletData = createSelector(agentsDisableWalletDataSelector, (data) => data);
export const selectDisableWalletError = createSelector(agentsDisableWalletErrorSelector, (error) => error);
export const selectDisableWalletIsFetching = createSelector(agentsDisableWalletFetchingSelector, (isFetching) => isFetching);

//Add Wallet
const agentsAddWalletDataSelector = (state: RootState) => state.agent.agents.addWallet.data;
const agentsAddWalletErrorSelector = (state: RootState) => state.agent.agents.addWallet.error;
const agentsAddWalletFetchingSelector = (state: RootState) => state.agent.agents.addWallet.isFetching;

export const selectAddWalletData = createSelector(agentsAddWalletDataSelector, (data) => data);
export const selectAddWalletError = createSelector(agentsAddWalletErrorSelector, (error) => error);
export const selectAddWalletIsFetching = createSelector(agentsAddWalletFetchingSelector, (isFetching) => isFetching);


//Agent Balance
const agentsAgentBalanceDataSelector = (state: RootState) => state.agent.agents.agentBalance.data;
const agentsAgentBalanceErrorSelector = (state: RootState) => state.agent.agents.agentBalance.error;
const agentsAgentBalanceFetchingSelector = (state: RootState) => state.agent.agents.agentBalance.isFetching;

export const selectAgentBalanceData = createSelector(agentsAgentBalanceDataSelector, (data) => data);
export const selectAgentBalanceError = createSelector(agentsAgentBalanceErrorSelector, (error) => error);
export const selectAgentBalanceIsFetching = createSelector(agentsAgentBalanceFetchingSelector, (isFetching) => isFetching);

//Create Player
const agentsCreatePlayerDataSelector = (state: RootState) => state.agent.agents.createPlayer.data;
const agentsCreatePlayerErrorSelector = (state: RootState) => state.agent.agents.createPlayer.error;
const agentsCreatePlayerFetchingSelector = (state: RootState) => state.agent.agents.createPlayer.isFetching;

export const selectCreatePlayerData = createSelector(agentsCreatePlayerDataSelector, (data) => data);
export const selectCreatePlayerError = createSelector(agentsCreatePlayerErrorSelector, (error) => error);
export const selectCreatePlayerIsFetching = createSelector(agentsCreatePlayerFetchingSelector, (isFetching) => isFetching);

//PlayerList
const agentsPlayerListDataSelector = (state: RootState) => state.agent.agents.playerList.data;
const agentsPlayerListErrorSelector = (state: RootState) => state.agent.agents.playerList.error;
const agentsPlayerListFetchingSelector = (state: RootState) => state.agent.agents.playerList.isFetching;

export const selectPlayerListData = createSelector(agentsPlayerListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectPlayerListDataColumnsSort = createSelector(agentsPlayerListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectPlayerListError = createSelector(agentsPlayerListErrorSelector, (error) => error);
export const selectPlayerListIsFetching = createSelector(agentsPlayerListFetchingSelector, (isFetching) => isFetching);


//Player Balance
const agentsPlayerBalanceDataSelector = (state: RootState) => state.agent.agents.playerBalance.data;
const agentsPlayerBalanceErrorSelector = (state: RootState) => state.agent.agents.playerBalance.error;
const agentsPlayerBalanceFetchingSelector = (state: RootState) => state.agent.agents.playerBalance.isFetching;

export const selectPlayerBalanceData = createSelector(agentsPlayerBalanceDataSelector, (data) => data);
export const selectPlayerBalanceError = createSelector(agentsPlayerBalanceErrorSelector, (error) => error);
export const selectPlayerBalanceIsFetching = createSelector(agentsPlayerBalanceFetchingSelector, (isFetching) => isFetching);

//PlayerList Details
const agentsPlayerListDetailsDataSelector = (state: RootState) => state.agent.agents.playerDetails.data;
const agentsPlayerListDetailsErrorSelector = (state: RootState) => state.agent.agents.playerDetails.error;
const agentsPlayerListDetailsFetchingSelector = (state: RootState) => state.agent.agents.playerDetails.isFetching;

export const selectPlayerListDetailsData = createSelector(agentsPlayerListDetailsDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'status') {
        return { ...item, type: 'playerStatus' };
      }
      if (item.name === 'balance') {
        return { ...item, type: 'playerBalance' };
      }
      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        country: item.country ? item.country.map((geo: string) => {
          return {
            id: geo.toLowerCase(),
            label: geo,
          }
        }) : []
      }
    });

    return { ...data, list: list, columns: columns };
  } else {
    return data;
  }
});
export const selectPlayerDetailsListError = createSelector(agentsPlayerListDetailsErrorSelector, (error) => error);
export const selectPlayerListDetailsIsFetching = createSelector(agentsPlayerListDetailsFetchingSelector, (isFetching) => isFetching);

//transferToAgent
const agentsTransferToAgentDataSelector = (state: RootState) => state.agent.agents.transferToAgent.data;
const agentsTransferToAgentErrorSelector = (state: RootState) => state.agent.agents.transferToAgent.error;
const agentsTransferToAgentFetchingSelector = (state: RootState) => state.agent.agents.transferToAgent.isFetching;

export const selectTransferToAgentData = createSelector(agentsTransferToAgentDataSelector, (data) => data);
export const selectTransferToAgentError = createSelector(agentsTransferToAgentErrorSelector, (error) => error);
export const selectTransferToAgentIsFetching = createSelector(agentsTransferToAgentFetchingSelector, (isFetching) => isFetching);

//Players Options
const agentsPlayersOptionsDataSelector = (state: RootState) => state.agent.agents.playersOptions.data;
const agentsPlayersOptionsErrorSelector = (state: RootState) => state.agent.agents.playersOptions.error;
const agentsPlayersOptionsFetchingSelector = (state: RootState) => state.agent.agents.playersOptions.isFetching;

export const selectPlayersOptionsData = createSelector(agentsPlayersOptionsDataSelector, (data) => data);
export const selectPlayersOptionsError = createSelector(agentsPlayersOptionsErrorSelector, (error) => error);
export const selectPlayersOptionsIsFetching = createSelector(agentsPlayersOptionsFetchingSelector, (isFetching) => isFetching);

//Players WalletIdentities
const agentsPlayerWalletIdentitiesDataSelector = (state: RootState) => state.agent.agents.playerWalletIdentities.data;
const agentsPlayerWalletIdentitiesErrorSelector = (state: RootState) => state.agent.agents.playerWalletIdentities.error;
const agentsPlayerWalletIdentitiesFetchingSelector = (state: RootState) => state.agent.agents.playerWalletIdentities.isFetching;

export const selectPlayerWalletIdentitiesData = createSelector(agentsPlayerWalletIdentitiesDataSelector, (data) => data);
export const selectPlayerWalletIdentitiesError = createSelector(agentsPlayerWalletIdentitiesErrorSelector, (error) => error);
export const selectPlayerWalletIdentitiesIsFetching = createSelector(agentsPlayerWalletIdentitiesFetchingSelector, (isFetching) => isFetching);

//transferToPlayer
const agentsTransferToPlayerDataSelector = (state: RootState) => state.agent.agents.transferToPlayer.data;
const agentsTransferToPlayerErrorSelector = (state: RootState) => state.agent.agents.transferToPlayer.error;
const agentsTransferToPlayerFetchingSelector = (state: RootState) => state.agent.agents.transferToPlayer.isFetching;

export const selectTransferToPlayerData = createSelector(agentsTransferToPlayerDataSelector, (data) => data);
export const selectTransferToPlayerError = createSelector(agentsTransferToPlayerErrorSelector, (error) => error);
export const selectTransferToPlayerIsFetching = createSelector(agentsTransferToPlayerFetchingSelector, (isFetching) => isFetching);

//PlayerProfile
const agentsPlayerProfileDataSelector = (state: RootState) => state.agent.agents.playerProfile.data;
const agentsPlayerProfileErrorSelector = (state: RootState) => state.agent.agents.playerProfile.error;
const agentsPlayerProfileFetchingSelector = (state: RootState) => state.agent.agents.playerProfile.isFetching;

export const selectPlayerProfileData = createSelector(agentsPlayerProfileDataSelector, (data) => data);
export const selectPlayerProfileError = createSelector(agentsPlayerProfileErrorSelector, (error) => error);
export const selectPlayerProfileIsFetching = createSelector(agentsPlayerProfileFetchingSelector, (isFetching) => isFetching);

//Update PlayerProfile
const agentsUpdatePlayerProfileDataSelector = (state: RootState) => state.agent.agents.updatePlayerProfile.data;
const agentsUpdatePlayerProfileErrorSelector = (state: RootState) => state.agent.agents.updatePlayerProfile.error;
const agentsUpdatePlayerProfileFetchingSelector = (state: RootState) => state.agent.agents.updatePlayerProfile.isFetching;

export const selectUpdatePlayerProfileData = createSelector(agentsUpdatePlayerProfileDataSelector, (data) => data);
export const selectUpdatePlayerProfileError = createSelector(agentsUpdatePlayerProfileErrorSelector, (error) => error);
export const selectUpdatePlayerProfileIsFetching = createSelector(agentsUpdatePlayerProfileFetchingSelector, (isFetching) => isFetching);

//AgentProfile
const agentsAgentProfileDataSelector = (state: RootState) => state.agent.agents.agentProfile.data;
const agentsAgentProfileErrorSelector = (state: RootState) => state.agent.agents.agentProfile.error;
const agentsAgentProfileFetchingSelector = (state: RootState) => state.agent.agents.agentProfile.isFetching;

export const selectAgentProfileData = createSelector(agentsAgentProfileDataSelector, (data) => data);
export const selectAgentProfileError = createSelector(agentsAgentProfileErrorSelector, (error) => error);
export const selectAgentProfileIsFetching = createSelector(agentsAgentProfileFetchingSelector, (isFetching) => isFetching);


//UpdateAgentProfile
const agentsUpdateAgentProfileDataSelector = (state: RootState) => state.agent.agents.updateAgentProfile.data;
const agentsUpdateAgentProfileErrorSelector = (state: RootState) => state.agent.agents.updateAgentProfile.error;
const agentsUpdateAgentProfileFetchingSelector = (state: RootState) => state.agent.agents.updateAgentProfile.isFetching;

export const selectUpdateAgentProfileData = createSelector(agentsUpdateAgentProfileDataSelector, (data) => data);
export const selectUpdateAgentProfileError = createSelector(agentsUpdateAgentProfileErrorSelector, (error) => error);
export const selectUpdateAgentProfileIsFetching = createSelector(agentsUpdateAgentProfileFetchingSelector, (isFetching) => isFetching);


//UpdateAgentRole
const agentsUpdateAgentRoleDataSelector = (state: RootState) => state.agent.agents.updateAgentRole.data;
const agentsUpdateAgentRoleErrorSelector = (state: RootState) => state.agent.agents.updateAgentRole.error;
const agentsUpdateAgentRoleFetchingSelector = (state: RootState) => state.agent.agents.updateAgentRole.isFetching;

export const selectUpdateAgentRoleData = createSelector(agentsUpdateAgentRoleDataSelector, (data) => data);
export const selectUpdateAgentRoleError = createSelector(agentsUpdateAgentRoleErrorSelector, (error) => error);
export const selectUpdateAgentRoleIsFetching = createSelector(agentsUpdateAgentRoleFetchingSelector, (isFetching) => isFetching);

//Filter roles
const agentsFilterRolesDataSelector = (state: RootState) => state.agent.agents.filterRoles.data;
const agentsFilterRolesErrorSelector = (state: RootState) => state.agent.agents.filterRoles.error;
const agentsFilterRolesFetchingSelector = (state: RootState) => state.agent.agents.filterRoles.isFetching;

export const selectFilterRolesData = createSelector(agentsFilterRolesDataSelector, (data) => data);
export const selectFilterRolesError = createSelector(agentsFilterRolesErrorSelector, (error) => error);
export const selectFilterRolesIsFetching = createSelector(agentsFilterRolesFetchingSelector, (isFetching) => isFetching);

//Block agent
const toggleBlockAgentDataSelector = (state: RootState) => state.agent.agents.blockAgent.data;
const toggleBlockAgentErrorSelector = (state: RootState) => state.agent.agents.blockAgent.error;
const toggleBlockAgentFetchingSelector = (state: RootState) => state.agent.agents.blockAgent.isFetching;

export const selectToggleBlockAgentData = createSelector(toggleBlockAgentDataSelector, (data) => data);
export const selectToggleBlockAgentError = createSelector(toggleBlockAgentErrorSelector, (error) => error);
export const selectToggleBlockAgentIsFetching = createSelector(toggleBlockAgentFetchingSelector, (isFetching) => isFetching);

//BetList filters
const betListFiltersDataSelector = (state: RootState) => state.agent.agents.betListFilters.data;
const betListFiltersErrorSelector = (state: RootState) => state.agent.agents.betListFilters.error;
const betListFiltersFetchingSelector = (state: RootState) => state.agent.agents.betListFilters.isFetching;

export const selectBetListFiltersData = createSelector(betListFiltersDataSelector, (data) => data);
export const selectBetListFiltersError = createSelector(betListFiltersErrorSelector, (error) => error);
export const selectBetListFiltersIsFetching = createSelector(betListFiltersFetchingSelector, (isFetching) => isFetching);

//Casino BetList filters
const casinoBetListFiltersDataSelector = (state: RootState) => state.agent.agents.casinoBetListFilters.data;
const casinoBetListFiltersErrorSelector = (state: RootState) => state.agent.agents.casinoBetListFilters.error;
const casinoBetListFiltersFetchingSelector = (state: RootState) => state.agent.agents.casinoBetListFilters.isFetching;

export const selectCasinoBetListFiltersData = createSelector(casinoBetListFiltersDataSelector, (data) => data);
export const selectCasinoBetListFiltersError = createSelector(casinoBetListFiltersErrorSelector, (error) => error);
export const selectCasinoBetListFiltersIsFetching = createSelector(casinoBetListFiltersFetchingSelector, (isFetching) => isFetching);

//agentNewPassword
const agentsNewPasswordDataSelector = (state: RootState) => state.agent.agents.agentNewPassword.data;
const agentsNewPasswordErrorSelector = (state: RootState) => state.agent.agents.agentNewPassword.error;
const agentsNewPasswordFetchingSelector = (state: RootState) => state.agent.agents.agentNewPassword.isFetching;

export const selectAgentNewPasswordData = createSelector(agentsNewPasswordDataSelector, (data) => data);
export const selectAgentNewPasswordError = createSelector(agentsNewPasswordErrorSelector, (error) => error);
export const selectAgentNewPasswordIsFetching = createSelector(agentsNewPasswordFetchingSelector, (isFetching) => isFetching);

//Block player
const toggleBlockPlayerDataSelector = (state: RootState) => state.agent.agents.blockPlayer.data;
const toggleBlockPlayerErrorSelector = (state: RootState) => state.agent.agents.blockPlayer.error;
const toggleBlockPlayerFetchingSelector = (state: RootState) => state.agent.agents.blockPlayer.isFetching;

export const selectToggleBlockPlayerData = createSelector(toggleBlockPlayerDataSelector, (data) => data);
export const selectToggleBlockPlayerError = createSelector(toggleBlockPlayerErrorSelector, (error) => error);
export const selectToggleBlockPlayerIsFetching = createSelector(toggleBlockPlayerFetchingSelector, (isFetching) => isFetching);

//Player status
const playerStatusDataSelector = (state: RootState) => state.agent.agents.playerStatus.data;
const playerStatusErrorSelector = (state: RootState) => state.agent.agents.playerStatus.error;
const playerStatusFetchingSelector = (state: RootState) => state.agent.agents.playerStatus.isFetching;

export const selectPlayerStatusData = createSelector(playerStatusDataSelector, (data) => data);
export const selectPlayerStatusError = createSelector(playerStatusErrorSelector, (error) => error);
export const selectPlayerStatusIsFetching = createSelector(playerStatusFetchingSelector, (isFetching) => isFetching);

//playerewPassword
const playerNewPasswordDataSelector = (state: RootState) => state.agent.agents.playerNewPassword.data;
const playerNewPasswordErrorSelector = (state: RootState) => state.agent.agents.playerNewPassword.error;
const playerNewPasswordFetchingSelector = (state: RootState) => state.agent.agents.playerNewPassword.isFetching;

export const selectPlayerNewPasswordData = createSelector(playerNewPasswordDataSelector, (data) => data);
export const selectPlayerNewPasswordError = createSelector(playerNewPasswordErrorSelector, (error) => error);
export const selectPlayerNewPasswordIsFetching = createSelector(playerNewPasswordFetchingSelector, (isFetching) => isFetching);
